// components/RegionAutoComplete.jsx

import { getRegionalManagerAutoComplete } from "app/services/RegionService";
import AsyncSelect from "react-select/async";

function RegionalManagerAutoComplete({
  value,
  onChange,
  placeholder = "Regional manager",
  isDisabled = false,
  name = "region",
}) {
  // load options only when typing
  const loadRegionOptions = async (inputValue) => {
    try {
      // prevent api call on refresh/open
      if (!inputValue || inputValue.trim().length < 1) {
        return [];
      }
      debugger;
      const response = await getRegionalManagerAutoComplete(inputValue);

      const options = (response?.data || []).map((item) => ({
        id: item.id,
        label: item.name,
        regionId: item.regionId,
      }));

      return options;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions={false}
      defaultOptions={false} // prevent auto api call
      value={value}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadRegionOptions}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable
      noOptionsMessage={({ inputValue }) =>
        !inputValue
          ? "Type to search regional manager"
          : "No regional manager found"
      }
      loadingMessage={() => "Searching..."}
    />
  );
}

export default RegionalManagerAutoComplete;
